import {Component, OnInit, Input } from '@angular/core';
import { DatePickerModel } from '../datepicker.model';
import { AbstractWorkflowResultComponent } from '../../@core/abstract-workflow-result.component';

@Component({
    selector: 'abw-datepicker-result',
    templateUrl: './datepicker-result.component.html',
    styleUrls: ['./datepicker-result.component.scss']
})
export class DatePickerResultComponent extends AbstractWorkflowResultComponent<DatePickerModel> {
}